<template>
  <div class="with-100 master-table-type">
    <el-table
      width="100%"
      style="width: 100% !important;"
      :data="result"
      :fit="true"
      v-show="isShow"
      class="table-size">

      <!--  オーナーID列  -->
      <el-table-column
        class-name="col-3"
        prop="ownerExId"
        :label="$t('label.system.owner.search.result.ownerId')" />

      <!--  オーナー名列  -->
      <el-table-column
        class-name="col-6"
        prop="ownerName"
        :label="$t('label.system.owner.search.result.ownerName')" />

      <!--  所有ビル列  -->
      <el-table-column
        class-name="col-7"
        :label="$t('label.system.owner.search.result.buildings')">
        <div slot-scope="scope">
          <div v-for="building of scope.row.buildings" :key="building.id">
            {{building.name}}
          </div>
        </div>
      </el-table-column>

      <!--   その他操作列   -->
      <el-table-column class-name="col-2">
        <div slot-scope="scope" class="detail-button with-100">
          <!--  照会バータン  -->
          <sp-smart-button @click="handleDetailAction(scope.row)" class="detailed-but with-100">{{$t('button.common.detail')}}</sp-smart-button>
        </div>
      </el-table-column>

       <el-table-column class-name="col-2" class="text-right">>
        <div slot-scope="scope" v-auth="{ auth: '010204'}" class="detail-button with-100">
          <el-popconfirm
            popper-class="iot-pop-confirm"
            :title="$t('message.system.owner.deleteConfirm')"
            :confirmButtonText="$t('button.common.ok')"
            :cancelButtonText="$t('button.common.cancel')"
            class="btn-operate"
            @onConfirm="handleDeleteAction(scope.row)">
            <sp-smart-button
              v-show="!scope.row.deleteFlag"
              slot="reference">
              {{$t("button.common.data.delete")}}
            </sp-smart-button>
          </el-popconfirm>
        </div>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
const EVENT_EDIT = "on-edit"
const EVENT_DETAIL = "on-detail"
const EVENT_DELETE = "on-delete"
const EVENT_MACHINE_IMPORT = "on-import-machine"
const EVENT_MACHINE_EXPORT = "on-export-machine"
import SpSmartButton from "@/components/common/sp-smart-button"

export default {
  name: "OwnerSearchResultBeautify",
  components:{
    SpSmartButton
  },
  data() {
    return {
      commands: {
        FUNCTION_SETUP: 1,
        MACHINE_IMPORT: 2,
        MACHINE_EXPORT: 3
      }
    }
  },
  props: {
    result: Array,
    isShow: Boolean
  },
  methods: {
    handleDetailAction(owner) {
      this.$emit(EVENT_DETAIL, owner.ownerId)
    },
    handleDeleteAction(owner) {
      this.$emit(EVENT_DELETE, owner.ownerId)
    },
    handleEditAction(owner) {
      this.$emit(EVENT_EDIT, owner.ownerId)
    },
    handleOtherAction(command) {
      switch (command.action) {
        case this.commands.MACHINE_EXPORT: {
          this.handleExportMachine(command.owner)
          break
        }
        case this.commands.FUNCTION_SETUP: {
          this.handleSetupFunction(command.owner)
          break
        }
        case this.commands.MACHINE_IMPORT: {
          this.handleImportMachine(command.owner)
          break
        }
      }
    },
    handleImportMachine(owner) {
      this.$emit(EVENT_MACHINE_IMPORT, owner.id)
    },
    handleExportMachine(owner) {
      this.$emit(EVENT_MACHINE_EXPORT, owner.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-operate {
  margin: 0 5px 0 0;
}
::v-deep .detail-button{
  button {
    width: 100%;
  }
  .my-button{
    width: 134px;
  }
}

::v-deep .detail-button .my-button {
  margin-left: 5px;
}
::v-deep .detail-button .my-button {
  width: 100%;
  height: 40px;
  line-height: 0;
}
</style>
